"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_BULK_PAYMENT_ACTION_TRANSACTIONS = void 0;
exports.MAX_BULK_PAYMENT_ACTION_TRANSACTIONS = 10_000;
